import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAllConfigCategories } from '@/hooks/useConfigItems';
import { setDbStatusCache, setWorkflowStatusCache } from '@/config/status-registry';
import { trpcClient } from '@/lib/trpc';

export function ConfigPrefetcher() {
  const { data: categories } = useAllConfigCategories();
  
  // Fetch all workflow transitions to sync colors/labels from DB
  const { data: transitions } = useQuery({
    queryKey: ['workflow-transitions', 'all'],
    queryFn: () => trpcClient.config.getAllWorkflowTransitions.query(),
    staleTime: 1000 * 60 * 30, // 30 mins
  });

  // Sync Categories & Items
  useEffect(() => {
    if (!categories || !Array.isArray(categories)) return;

    let count = 0;
    for (const cat of categories) {
      if (cat.code && Array.isArray(cat.items) && cat.items.length > 0) {
        setDbStatusCache(cat.code, cat.items);
        count++;
      }
    }

    if (count > 0) {
      // console.log(`[ConfigPrefetcher] Loaded ${count} config categories from DB`);
    }
  }, [categories]);

  // Sync Workflow Transitions (colors)
  useEffect(() => {
    if (transitions && Array.isArray(transitions)) {
      setWorkflowStatusCache(transitions);
      // console.log(`[ConfigPrefetcher] Loaded ${transitions.length} workflow transitions from DB`);
    }
  }, [transitions]);

  return null;
}
